import React, { useState, useEffect } from 'react';
import { Box, Typography, Select, MenuItem, FormControl, InputLabel, SelectChangeEvent } from '@mui/material';
import FocusGroupInsights from '../../components/FocusGroupInsights';
// import { MOCK_FOCUS_GROUPS } from '../../data/focus_groups_sessions';
import { useFocusGroupSessions } from '../../hooks/communityhook';

const FocusGroupInsightsPage: React.FC = () => {
  const { formattedFocusGroupSessions } = useFocusGroupSessions()
  const [selectedSession, setSelectedSession] = useState<string>('');

  useEffect(() => {
    if (formattedFocusGroupSessions.length > 0) {
      setSelectedSession(formattedFocusGroupSessions[0].id);
    }
  }, [formattedFocusGroupSessions]);

  const handleSessionChange = (event: SelectChangeEvent) => {
    setSelectedSession(event.target.value);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Data Insights
      </Typography>
      
      <FormControl fullWidth sx={{ mb: 3 }}>
        <InputLabel id="session-select-label">Select Session</InputLabel>
        <Select
          labelId="session-select-label"
          value={selectedSession}
          label="Select Session"
          onChange={handleSessionChange}
        >
          {formattedFocusGroupSessions.map(session => (
            <MenuItem key={session.id} value={session.id}>
              Session {session.sessionNumber} - {session.title} ({session.sessionDate.format('MMM D, YYYY @ hh:mm a')})
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedSession && <FocusGroupInsights sessionId={selectedSession} />}
    </Box>
  );
};

export default FocusGroupInsightsPage; 